const doc = [({"csv_header":["Team", "Member", "Application", "Target Date", "Usage Time"]})];
module.exports = doc.length <= 1 ? doc[0] : doc;